import { friendInviteFeedback } from "../Helpers/friendInviteFeedback";
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

G.HighscorePanel2 = function HighscorePanel2(game, rewardCoins) {

  function getJson(key) { return G.json[key]; }

  var screenSize = {
    width:  G.l(640),
    // TODO: Should use game.height, but SVG->json doesn't support keeping aspect ratio yet
    height: G.l(960)
  };

  var stateTracker = G.AsyncUtils.createPhaserStateStatusTracker(game);

  var animator = G.HighscorePanel2Helper.createAnimator(game);

  var overlay = G.HighscorePanel2Helper.addOverlay(toggle);

  var mainContainer = createMainContainer();

  var ui = G.UI.createUIElement(game, getJson('ui/leaderboard/leaderboard'), 1, 1, getJson);
  
  mainContainer.add(ui.rootElement);

  G.UI.resize(ui.rootElement, screenSize.width, screenSize.height);

  ui.exports.forEvery(
    'mask',
    function(element, index, exports) { G.HighscorePanel2Helper.addMaskTo(element); }
  );

  ui.exports.forEvery(
    'r2t',
    function(element) { G.HighscorePanel2Helper.r2t(element); }
  );

  var toggleManager = createToggleManager(game, ui.exports, animator);
  ui.exports.getFirst('button_toggle').rootElement.onClick.add(toggle);

  var ShowWaitingIconReason = {
    LoadingInProgress: 'loadingInProgress',
    Transitioning:     'transitioning'
  }
  var waitingIconsMgr = G.HighscorePanel2Helper.createWaitingIconsManager(
    ui.exports, 'load_placeholder',
    animator
  );
  waitingIconsMgr.showReasons.add(ShowWaitingIconReason.LoadingInProgress);

  initInviteButtons(
    ui.exports,
    'invite_friends_button_small',
    'invite_friends_button_large',
    'animate_squish_squash'
  );

  if (OMT.feature.isGiftingSupported()) {
    var tabs = {
      //rating: initTab(ui.exports.getFirst('tab_1'), true)
    };
    const tab2 = ui.exports.getFirst('tab_2').rootElement;
    tab2.visible = false;
    tab2.exists = false;
    const tab1 = ui.exports.getFirst('tab_1').rootElement;
    tab1.visible = false;
    tab1.exists = false;
    const tab2Background = ui.exports.getFirst('hide_if_gift_disabled').rootElement;
    tab2Background.visible = false;
    tab2Background.exists = false;
  } else {

    var tabs = {
      rating: initTab(ui.exports.getFirst('tab_1'), true)
    };

    const tab1= ui.exports.getFirst('tab_1').rootElement;
    tab1.visible = false;
    tab1.exists = false;

    const tab2 = ui.exports.getFirst('tab_2').rootElement;
    tab2.visible = false;
    tab2.exists = false;
    const tab2Background = ui.exports.getFirst('hide_if_gift_disabled').rootElement;
    tab2Background.visible = false;
    tab2Background.exists = false;

    const root = ui.exports.getFirst('lb_moveable').rootElement;
    root.visible = false;
    root.exists = false;
  }

  var contentManager = G.createHighscorePanel2ContentManager(
    game, rewardCoins, stateTracker, animator,
    ui.exports.getFirst('content_minimized').rootElement,
    ui.exports.getFirst('lb_entry_size_small_first').rootElement.customComponents.ui,
    ui.exports.getFirst('lb_entry_size_small_next').rootElement.customComponents.ui,
    ui.exports.getFirst('content_expanded').rootElement,
    ui.exports.getFirst('lb_entry_size_large_first').rootElement.customComponents.ui,
    ui.exports.getFirst('lb_entry_size_large_next').rootElement.customComponents.ui
  );
  var ContentGroup = contentManager.ContentGroup;

  var showRatingsFallbackReasons = new G.Reasons(function(show) {
    show ? animateShow(ui.exports, 'fallback') : animateHide(ui.exports, 'fallback');
  });

  installAutoHideHook(ui.rootElement);

  var signals = {
    expanded:  new Phaser.Signal(),
    minimized: new Phaser.Signal()
  };

  var ratingsLoaded = G.AsyncUtils.createFuturePromise();
  var livesLoaded   = G.AsyncUtils.createFuturePromise();

  var schedulers = {
    changeExpandedSlow: G.AsyncUtils.createScheduler(game, toggleManager.duration),
    changeExpandedFast: G.AsyncUtils.createScheduler(game, animator.getDuration()),
    changeTab:          G.AsyncUtils.createScheduler(game, animator.getDuration())
  };

  if (OMT.feature.isGiftingSupported()) {

    if (G.OMTsettings.elements.leaderboard.tabLivesSelected) selectTabLives();

    if (OMT.connect.isConnected()) {
      loadAndShowData();
    } else { // delay for connection if needed
      loadAndShowData();
      OMT.connect.signals.onGBConnected.addOnce(() => {
        animateHide(ui.exports, 'fallback');
        loadAndShowData();
      });
    }
  }

  return {
    signals: signals,
    expandLivesList: expandLivesList,
  };

  function expandLivesList() {
    if (!toggleManager.expanded) toggle();
  }

  //

  function createMainContainer() {
    var group = game.add.group();
    group.updateOnlyExistingChildren = true;
    group.pivot.set(0.5 * screenSize.width, screenSize.height);
    updateRootPosition();
    G.sb('onScreenResize').add(updateRootPosition);

    return group;

    function updateRootPosition() {
      group.x = 0.5 * screenSize.width;
      group.y = game.height;
    }
  }

  function installAutoHideHook(objectToHide) {

    var Animations = G.Animations;
    var createTranslateXYCubicOutAnimation = Animations.Generic.createTranslateXYCubicOutAnimation;

    var duration = 1000;

    // FIXME: get from UI json
    var hideOffset = 500;
    var translateAppearAnim = createTranslateXYCubicOutAnimation(0, 0, duration);    
    var translateHideAnim   = createTranslateXYCubicOutAnimation(0, hideOffset, duration);

    var scheduler = G.AsyncUtils.createScheduler(game, duration);

    if (G.PRELEVEL_PER_LEVEL_LEADERBOARD) {
      G.sb('levelWindowOpen').add(hide);
      G.sb('levelWindowClose').add(unhide);
    }
    G.sb('hideMainHighscorePanel').add(hide);
    G.sb('showMainHighscorePanel').add(unhide);

    return;

    // TODO: resolve animations intersection conflict
    function unhide() {
      scheduler.cancelSchedule();
      showInstant(objectToHide);
      translateAppearAnim.animate(game, objectToHide);
      
    }
    function hide() {
      translateHideAnim.animate(game, objectToHide);
      scheduler.rescheduleAction(function() { hideInstant(objectToHide); });
    }
    function showInstant(object) {
      object.visible = true;
      object.exists = true;
    }
    function hideInstant(object) {
      object.visible = false;
      object.exists = false;
    }
  }

  // TODO: move invite functionality to OMT_Social
  function initInviteButtons(exports, nameSmall, nameLarge, nameAnimate) {

    exports.forEvery(
      nameSmall,
      function(button, index, exports) {

        button.onClick.add(async function() {
          DDNA.tracking.socialActionEvent("INVITE", "", "");
          let result = await OMT.social.chooseContextAndInvite();
          
          if (result) {
            showFriendInviteFeedback();
          }
        });
      },
      true
    );

    if (nameLarge) {
      const container = exports.getFirst('helper_animate_maximized').rootElement;
      _.forEach(container.children, (child) => {
        child.destroy();
      });
      container.removeChildren();
      const inviteFriendsClick = async () => {
        DDNA.socialTracker.incrementParam('numFriendsInvites', 1);
        DDNA.tracking.socialActionEvent('INVITE', '', '', '');
        const result = await OMT.social.chooseContextAndInvite();

        if (result) {
          showFriendInviteFeedback();
          OMT.platformTracking.logEvent(OMT.platformTracking.Events.InviteFromLeaderboardExpanded);
        }
      };
      const inviteButtonLarge = new OMT_UI_SquareButton(0, 0, { // Hijack
        button: {
          tint: BUTTONCOLOURS.green,
          dimensions: {
            width: 247.2,
            height: 80,
          },
        },
        text: {
          string: OMT.language.getText('Add More Friends'),
          style: {
            style: 'font-white',
            fontSize: 196,
          },
        },
        options: {
          clickFunction: {
            scaleOnClick: false,
          },
        },
      });
      exports.getFirst(nameLarge).rootElement.onClick.add(inviteFriendsClick, this);
      container.addChild(inviteButtonLarge);
      inviteButtonLarge.x += inviteButtonLarge.width / 2;
      inviteButtonLarge.y += inviteButtonLarge.height / 2;
    }

    exports.forEvery(
      nameAnimate,
      function(element, index, exports) {

        var animation = G.Animations.Generic.getSquishSquashAnimation(element.scale.x);
        animation.animate(game, element);
      }
    );
  }

  //

  async function loadAndShowData() {

    var ratingsLoadedWaiter = G.AsyncUtils.createWaiter(game);

    ratingsLoadedWaiter.signals.stoppedBeforeTimeout.addOnce(
      function(succeed) { if (!succeed) { showRatingsFallbackReasons.add('failed'); }
    });

    ratingsLoadedWaiter.signals.timedOut.addOnce(function() {
      showRatingsFallbackReasons.add('timedOut');
      ratingsLoaded.control.fulfill(false);
    });

    ratingsLoadedWaiter.signals.stoppedAfterTimeout.addOnce(function(succeed) {
      if (!succeed) { showRatingsFallbackReasons.add('failed'); }
      showRatingsFallbackReasons.remove('timedOut');
    });
    
    ratingsLoadedWaiter.startWaiting(5000);

    // get the users friends list
    try {
      let friendsList = await OMT.friends.getFriendsList();
      getFriendsSucceed(friendsList);
    } catch(error) { 
      getFriendsFailed(error);
    }

    // get default / global leaderboard
    try {
      let entriesArray = await OMT.leaderboards.getLeaderBoardEntries('default','default');
      getRanksSucceed(entriesArray)
    } catch(error) {
      getRanksFailed(error);
    }

    ratingsLoaded.read.promise.then(function() {
      waitingIconsMgr.showReasons.remove(ShowWaitingIconReason.LoadingInProgress);
    });

    livesLoaded.read.promise.then(function(succeed) {
      waitingIconsMgr.showReasons.remove(ShowWaitingIconReason.LoadingInProgress);
    });

    return;

    function getRanksSucceed(entriesArray) {

      if (!stateTracker.isAlive()) return;

      if (entriesArray.length > 0) {
        ratingsLoadedWaiter.stopWaiting(true);
        ratingsLoaded.control.fulfill(true);
        contentManager.setRatingsData(entriesArray);
      } else {
        ratingsLoadedWaiter.stopWaiting(false);
        ratingsLoaded.control.fulfill(false);
      }
    }

    function getRanksFailed(error) {
      if (!stateTracker.isAlive()) return;

      console.error('Failed to get ranks:', error);
      ratingsLoadedWaiter.stopWaiting(false);
      ratingsLoaded.control.fulfill(false);
    }

    function getFriendsSucceed(friends) {
      if (!stateTracker.isAlive()) return;
      livesLoaded.control.fulfill(true);
      contentManager.setLivesData(friends);
    }

    function getFriendsFailed(error) {
      if (!stateTracker.isAlive()) return;
      console.log(error);
      livesLoaded.control.fulfill(false);
    }

  }

  //

  function createToggleManager(game, exports, animator) {

    var getFirst = createGetFirstHelper(exports);

    var DURATIONS = {
      MOVE_ALL:   750,
      MOVE_GINGY: 666,
      MORPH:      350
    };

    var PositionName = {
      Expanded:  'expanded',
      Minimized: 'minimized'
    };

    var elementsCache = { toggleDirectionIcon: getFirst('button_toggle_icon', true) };

    var animators = {
      toggle: createAnimator(
        PositionName.Minimized, getFirst('lb_moveable'),
        PositionName.Expanded,  getFirst('lb_expanded_target_position')
      ),
      gingy: createAnimator(
        PositionName.Minimized, getFirst('gingy'),
        PositionName.Expanded,  getFirst('gingy_target'),
        true
      ),
      buttonSmall: createAnimator(
        PositionName.Minimized, getFirst('invite_friends_small'),
        PositionName.Expanded,  getFirst('invite_friends_large'),
        true, Phaser.Easing.Custom.SoftBounce, true
      ),
      buttonLarge: createAnimator(
        PositionName.Expanded,  getFirst('invite_friends_large'),
        PositionName.Minimized, getFirst('invite_friends_small'),
        true, Phaser.Easing.Custom.SoftBounce, true
      )
    };

    animators.buttonLarge.setPosition(PositionName.Minimized);

    var toggleManager = {
      duration: DURATIONS.MOVE_ALL,
      expanded: false,
      animateExpand:   animateExpand,
      animateMinimize: animateMinimize
    };

    return toggleManager;

    function animateExpand()   { doAnimate(PositionName.Expanded,  0);   }
    function animateMinimize() { doAnimate(PositionName.Minimized, 180); }

    function doAnimate(positionName, toggleIconAngle) {
      animators.toggle.animateToPosition(positionName, DURATIONS.MOVE_ALL);
      animators.gingy.animateToPosition(positionName, DURATIONS.MOVE_GINGY);
      animators.buttonSmall.animateToPosition(positionName, DURATIONS.MORPH);
      animators.buttonLarge.animateToPosition(positionName, DURATIONS.MORPH);

      if (positionName === PositionName.Expanded) {
        animator.hide(animators.buttonSmall.target);
        animator.show(animators.buttonLarge.target);
      } else {
        animator.hide(animators.buttonLarge.target);
        animator.show(animators.buttonSmall.target);
      }

      if (elementsCache.toggleDirectionIcon) {
        var rotateToggleIconAnim = (
          G.Animations.Generic.createRotateCubicOutAnimation(toggleIconAngle, DURATIONS.MORPH)
        );
        rotateToggleIconAnim.animate(game, elementsCache.toggleDirectionIcon);
      }
    }

    //

    function createAnimator(
      positionNameStart, target,
      positionNameEnd,   expandedTarget,
      optAnimateScale, optEasing, optCopyTargetPosition
    ) {
      var animator = G.AnimationUtils.createPositionAnimator(
        game, target, true, positionNameStart, Boolean(optAnimateScale), optEasing
      );
      animator.addPosition(positionNameEnd, expandedTarget, Boolean(optCopyTargetPosition));
      return animator;
    }

    function createGetFirstHelper(exports) {
      return getFirst;
      function getFirst(name, optOptional) {
        if (optOptional) return exports.getFirst(name, 'warn').rootElement;
        return exports.getFirst(name).rootElement;
      }
    }
  }

  function toggle() {

    if (schedulers.changeExpandedSlow.isRunning()) return;

    toggleManager.expanded = !toggleManager.expanded;

    waitingIconsMgr.showReasons.add(ShowWaitingIconReason.Transitioning);

    if (toggleManager.expanded) {

      toggleManager.animateExpand();

      animateHide(ui.exports, 'invisible_when_expanded');
      contentManager.hideCurrentGroup();
      schedulers.changeExpandedFast.rescheduleAction(function() {
        animateShow(ui.exports, 'visible_when_expanded');
      });
      schedulers.changeExpandedSlow.rescheduleAction(function() {
        waitingIconsMgr.showReasons.remove(ShowWaitingIconReason.Transitioning);
        contentManager.showGroup( ContentGroup.LivesLarge );
      });
      overlay.showOverlay();

      signals.expanded.dispatch();

    } else {

      toggleManager.animateMinimize();

      animateHide(ui.exports, 'visible_when_expanded');
      contentManager.hideCurrentGroup();
      schedulers.changeExpandedFast.rescheduleAction(function() {
        animateShow(ui.exports, 'invisible_when_expanded');
      });
      schedulers.changeExpandedSlow.rescheduleAction(function() {
        waitingIconsMgr.showReasons.remove(ShowWaitingIconReason.Transitioning);
        contentManager.showGroup( ContentGroup.LivesSmall );
      });
      overlay.hideOverlay();

      signals.minimized.dispatch();
    }
  }

  //

  function initTab(result, optInitiallyActive) {

    var rootElement = result.rootElement;
    var button = result.exports.getFirst('button').rootElement;
    var activeImg = result.exports.getFirst('active', 'warn').rootElement;

    var active = Boolean(optInitiallyActive);

    return {
      isActive: isActive,
      onClick: button.onClick,
      activate: activate,
      deactivate: deactivate 
    };

    function isActive() { return active; }

    function activate() {
      active = true;
      activeImg && animator.show(activeImg);
    }

    function deactivate() {
      active = false;
      activeImg && animator.hide(activeImg);
    }
  }

  function selectTabRating() {
    if (schedulers.changeTab.isRunning()) return;

    contentManager.hideCurrentGroup();

    schedulers.changeTab.rescheduleAction(function() {

      waitingIconsMgr.showReasons.setPresence(
        ShowWaitingIconReason.LoadingInProgress,
        !ratingsLoaded.read.isSettled()
      );

      animateShow(ui.exports, 'visible_when_tab_1_active');

      contentManager.showGroup(
        toggleManager.expanded ? ContentGroup.RatingLarge : ContentGroup.RatingSmall
      );
    });
  }

  function selectTabLives() {
    if (schedulers.changeTab.isRunning()) return;

    animateHide(ui.exports, 'visible_when_tab_1_active');

    contentManager.hideCurrentGroup();

    schedulers.changeTab.rescheduleAction(function() {

      waitingIconsMgr.showReasons.setPresence(
        ShowWaitingIconReason.LoadingInProgress, 
        !(
          livesLoaded.read.isSettled() &&
          livesLoaded.read.isSucceed() &&
          livesLoaded.read.getValue()
        )
      );

      contentManager.showGroup(
        toggleManager.expanded ? ContentGroup.LivesLarge : ContentGroup.LivesSmall
      );
    });
  }

  //

  function animateHide(exports, name) {
    exports.forEvery(name, function(element, index, exports) { animator.hide(element); });
  }

  function animateShow(exports, name) {
    exports.forEvery(name, function(element, index, exports) { animator.show(element); });
  }

  function showFriendInviteFeedback() {
    let feedback = new friendInviteFeedback(G.game, null);
    feedback.x = game.width/2;
    feedback.y = feedback.height/2;
    game.world.addChild(feedback);

    feedback.enterAndSelfDestroy();
  }

};
